export function getDefaultedBy<T>(initialValue: T, nullCase: T): T {
  return initialValue ? initialValue : nullCase;
}
